export default function EmailInput(props) {

  return (
    <input className="form__fields__input form__fields__email" name={props.name}  id={props.label} type="email" placeholder={props.label} required={props.required} />
  );
}
